<ng-container *ngIf="{ options: options$ | async } as obs">
  @if (obs.options) {
    @switch (obs.options.modalType) {
      @case ('compact') {
        <sd-modal-compact [options]="obs.options" (closed)="closeModal()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </sd-modal-compact>
      }
      @case ('standard') {
        <sd-modal-standard [options]="obs.options" (closed)="closeModal()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </sd-modal-standard>
      }
      @case ('fullscreen') {
        <sd-modal-fullscreen [options]="obs.options" (closed)="closeModal()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </sd-modal-fullscreen>
      }
    }

    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>

    <div class="sd-modal__backdrop" (click)="onBackdropClick()"></div>
  }
</ng-container>
